export const ENGINE_STEPS = [
  ['brief','Brief & sources'],
  ['generate','Generate & import'],
  ['review','Output & quality'],
  ['handoff','History & handoff'],
]
export function engineStepFor(job,requested){
  if(ENGINE_STEPS.some(([id])=>id===requested))return requested
  if(!job?.artworkEngine)return 'brief'
  return job.artworkEngine.outputAssetId?'review':'generate'
}
export const BEZEL_STEPS = [['source','Choose source'],['edit','Logo & edit areas'],['return','Render & inspect']]
export function bezelStepFor(requested,hasJob=false){return BEZEL_STEPS.some(([id])=>id===requested)?requested:hasJob?'edit':'source'}
export function workflowParams(params,key,value){const next=new URLSearchParams(params);next.set(key,value);return next}
